var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    rx: 4,
    fill: "#F1F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.3048V27H28V14.3048C28 13.0717 27.4313 11.9075 26.4586 11.1496L16 3L5.5414 11.1496C4.56873 11.9075 4 13.0717 4 14.3048Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14V26H26V14C26 13.4477 25.5523 13 25 13H7C6.44772 13 6 13.4477 6 14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21V26.9996H15.5714V21H7Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1172 23.1427V21H12.4548V23.1427H11H10.1172Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2598 21V26.9996H24.8312V21H16.2598Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.377 23.1427V21H21.7146V23.1427H20.5H19.377Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15V20.9996H20.5714V15H12Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1172 17.1427V15H17.4548V17.1427H16.2414H15.1172Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 4,
    height: 3,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseDelivery);
export default __webpack_public_path__ + "static/media/warehouse-delivery.690c3ad45ee9422a777a7dd1bd67c310.svg";
export { ForwardRef as ReactComponent };